import React, { useState, useEffect } from "react";
import CtaLayout from "./CtaLayout";
import "../../styles/common.css";
import "../../styles/cta.css";


function CtaBranding() {

  return (
    <>
      <CtaLayout title="Contact Us" lead="CONTACT">
        <div className='cta-box__text'>
          <h3>Please consult us from logo design creation to sales strategy planning.</h3>
          <p>We offer consulting support services using the know-how gained from our branding support services to win against competitors and our web marketing agency services to get web customer acquisition on track.<br />First, please feel free to tell us about your products or services.</p>
        </div>
      </CtaLayout>
    </>
  );
}

export default CtaBranding;
